import React from 'react'

import { Alert, Box, Text } from '@factorialco/deprecated-design-system'

import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

import { AtsMessageVariablesSelector } from 'modules/ats/components/AtsMessageVariablesSelector'
import { MessageTemplatesSelector } from 'modules/ats/components/message_templates/MessageTemplatesSelector'
import { useMessageTemplatesFeatureAvailability } from 'modules/ats/hooks/features/useMessageTemplatesFeatureAvailability'
import { HTMLToPlainText } from 'modules/ats/lib/utils/domparser'

import { CreateInterviewData } from './CreateInterviewData'

interface Props {
  data: CreateInterviewData
  onDataChanged: (data: CreateInterviewData) => void
}

export const isMessageCompleted = (data: CreateInterviewData) => !!data.messageContent

export const MessageStep = ({ data, onDataChanged }: Props) => {
  const [messageContent, setMessageContent] = React.useState<string | undefined>(undefined)
  const hasMessageTemplatesFeature = useMessageTemplatesFeatureAvailability()

  const onChangeSelectedMessageTemplate = (messageTemplateContent: string) => {
    setMessageContent(messageTemplateContent)
    onDataChanged({
      ...data,
      messageContent: HTMLToPlainText(messageTemplateContent || ''),
    })
  }

  const addVariable = (variable: string) => {
    onDataChanged({
      ...data,
      messageContent: `${data.messageContent} ${variable}`,
    })
  }

  return (
    <Box gap="s16">
      <Box>
        {hasMessageTemplatesFeature && (
          <Box flexDirection="row" justifyContent="spaceBetween" alignItems="flexEnd">
            <Box width="s400" gap="s4">
              <Text.Normal size="200" color="grey1000" weight="medium">
                {i18n.t('ats.schedule_interview.steps.message.message')}
              </Text.Normal>
              <MessageTemplatesSelector
                onMessageTemplateChanged={onChangeSelectedMessageTemplate}
              />
            </Box>
            <AtsMessageVariablesSelector onSelect={addVariable} showJobData showSenderData />
          </Box>
        )}
      </Box>
      <TextArea
        onChange={(value) => {
          onDataChanged({
            ...data,
            messageContent: value.toString() || '',
          })
        }}
        value={data.messageContent || ''}
        info={i18n.t('ats.schedule_interview.steps.message.html_alert')}
        showInfo={!!messageContent}
        placeholder={i18n.t('ats.schedule_interview.steps.message.start_typing')}
      />
      <Alert>{i18n.t('ats.schedule_interview.steps.message.attach_alert')}</Alert>
    </Box>
  )
}
